
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Слой_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 333 500","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M35.2 490.8c-12.2-12.2-12.2-32 0-44.1L231.6 250 35.2 53.3C23 41.2 23 21.4 35.2 9.2s32-12.2 44.1 0l218.5 218.7c12.2 12.2 12.2 32 0 44.1L79.3 490.8a30.965 30.965 0 01-44.1 0z"}})])
          )
        }
      }
    